import { render } from "./BussinessGroup.vue?vue&type=template&id=23b726a3&scoped=true"
import script from "./BussinessGroup.vue?vue&type=script&lang=js"
export * from "./BussinessGroup.vue?vue&type=script&lang=js"

import "./BussinessGroup.vue?vue&type=style&index=0&id=23b726a3&lang=css"
import "./BussinessGroup.vue?vue&type=style&index=1&id=23b726a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b726a3"]])

export default __exports__